<div class="px-2 sm:px-4 md:px-6 py-4 max-w-4xl mx-auto">
  <!-- Header -->
  <div class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mb-6">
    <h1 class="text-2xl font-bold text-gray-800 flex items-center">
      <mat-icon style="color: #1C593D; margin-right: 8px;">inbox</mat-icon>
      Bandeja de Notificaciones
      <!-- Badge desktop -->
      <span *ngIf="unreadCount > 0"
        class="hidden md:inline text-sm font-semibold bg-red-100 text-red-700 px-3 py-1 rounded-full ml-2">
        {{ unreadCount }} sin leer
      </span>
    </h1>
    <button *ngIf="unreadCount > 0" type="button" (click)="markAllAsRead()"
      style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 36px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
      onmouseover="this.style.background='#059669'"
      onmouseout="this.style.background='#1C593D'">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">done_all</mat-icon>
      Marcar todo como leído
    </button>
  </div>
  <!-- Badge mobile -->
  <span *ngIf="unreadCount > 0"
    class="md:hidden inline-block text-sm font-semibold bg-red-100 text-red-700 px-3 py-1 rounded-full mb-4">
    {{ unreadCount }} sin leer
  </span>

  <!-- Empty state -->
  <div *ngIf="messages.length === 0" class="text-center py-16">
    <mat-icon style="font-size: 64px; width: 64px; height: 64px; color: #d1d5db;">mail_outline</mat-icon>
    <p class="text-gray-400 mt-4 text-sm">No tienes notificaciones</p>
  </div>

  <!-- Messages list -->
  <div class="space-y-2">
    <div *ngFor="let msg of messages"
      class="bg-white rounded-xl shadow-sm border overflow-hidden transition-all duration-200"
      [style.borderColor]="expandedId === msg.id ? '#1C593D' : !msg.readAt ? '#bbf7d0' : '#e5e7eb'"
      [style.borderLeftWidth]="!msg.readAt ? '3px' : '1px'"
      [style.borderLeftColor]="!msg.readAt ? '#1C593D' : '#e5e7eb'">

      <!-- Message header -->
      <div class="flex items-center justify-between p-3 cursor-pointer"
        (click)="toggleMessage(msg)"
        [style.background]="expandedId === msg.id ? '#f0fdf4' : !msg.readAt ? '#fafffe' : 'white'">
        <div class="flex items-center gap-3 flex-1 min-w-0">
          <div class="shrink-0 rounded-full"
            style="width: 36px; height: 36px; display: flex; align-items: center; justify-content: center;"
            [style.background]="!msg.readAt ? '#ecfdf5' : '#f3f4f6'">
            <mat-icon
              [style.color]="!msg.readAt ? '#1C593D' : '#9ca3af'"
              style="font-size: 20px; width: 20px; height: 20px;">
              {{ !msg.readAt ? 'mark_email_unread' : 'mail' }}
            </mat-icon>
          </div>
          <div class="min-w-0 flex-1">
            <span class="text-sm font-semibold truncate block"
              [style.color]="!msg.readAt ? '#111827' : '#6b7280'">
              {{ msg.subject }}
            </span>
            <div class="flex items-center gap-2 mt-0.5">
              <span class="text-xs text-gray-400">Mensaje de operador</span>
              <span class="text-xs text-gray-300">&middot;</span>
              <span class="text-xs text-gray-400">{{ getTimeAgo(msg.createdAt) }}</span>
            </div>
          </div>
        </div>
        <mat-icon class="text-gray-400 shrink-0 transition-transform duration-200"
          [style.transform]="expandedId === msg.id ? 'rotate(180deg)' : 'rotate(0)'">
          expand_more
        </mat-icon>
      </div>

      <!-- Message body (expanded) -->
      <div *ngIf="expandedId === msg.id" class="px-4 pb-4 border-t border-gray-100">
        <div class="mt-3">
          <div class="text-xs text-gray-400 mb-1">
            Mensaje de operador &middot; {{ formatDate(msg.createdAt) }}
          </div>
          <div class="text-sm leading-relaxed whitespace-pre-wrap"
            style="background: #f9fafb; padding: 12px 16px; border-radius: 8px; color: #374151;">
            {{ msg.body }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Pagination -->
  <div *ngIf="totalPages > 1" class="flex items-center justify-center gap-4 mt-6">
    <button type="button"
      [disabled]="currentPage <= 1"
      (click)="onPageChange(-1)"
      [style.opacity]="currentPage <= 1 ? '0.4' : '1'"
      style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
      onmouseover="this.style.background='#f3f4f6'"
      onmouseout="this.style.background='white'">
      Anterior
    </button>
    <span class="text-sm text-gray-500">
      Página {{ currentPage }} de {{ totalPages }}
    </span>
    <button type="button"
      [disabled]="currentPage >= totalPages"
      (click)="onPageChange(1)"
      [style.opacity]="currentPage >= totalPages ? '0.4' : '1'"
      style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
      onmouseover="this.style.background='#f3f4f6'"
      onmouseout="this.style.background='white'">
      Siguiente
    </button>
  </div>
</div>
